<template>
    <div class="w-100">
        <div class="d-flex w-100">
            <div style="width: calc(200% / 3)" class="mr-4">
                <div class="d-flex">
                    <v-text-field @input="setEntitiesSearch" :value="entitiesSearch" append-icon="mdi-magnify" label="Rechercher par nom"
                                  clearable class="mb-4" outlined hide-details :disabled="!canSearch">
                    </v-text-field>
                    <v-text-field @input="setEntitiesEmailSearch" :value="entitiesEmailSearch" append-icon="mdi-magnify"
                                  label="Rechercher par email" clearable class="mb-4 ml-4" outlined hide-details
                                  :disabled="!canSearch">
                    </v-text-field>
                </div>

                <div class="d-flex">
                    <v-select :label="cityWording" outlined chips small-chips deletable-chips :items="communes"
                              @input="setEntitiesSelectedCommunes" :value="entitiesSelectedCommunes" item-value="id" item-text="label"
                              class="w-50" multiple>
                    </v-select>

                    <v-select label="Secteur touristique" outlined chips small-chips deletable-chips :items="tourismSectors"
                              @input="setEntitiesSelectedTourismSectors" :value="entitiesSelectedTourismSectors" item-value="id" item-text="label"
                              class="w-50 ml-4" multiple v-if="this.account.tis_type.code === 'DAHUB_QUEBEC'">
                    </v-select>
                </div>

            </div>

            <div style="width: calc(100% / 3)">
                <v-select label="Tag" outlined chips @input="setEntitiesSelectedTags" :items="tags" :value="entitiesSelectedTags"
                          no-data-text="Aucun tag n'a encore été créé" small-chips deletable-chips item-value="id"
                          item-text="name" multiple>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
export default {
    name: "EntitiesFilters",
    data() {
        return {
            cityWording: 'Commune',
        }
    },
    methods: {
        ...mapMutations("entitiesFilter", [
            "setEntitiesSearch",
            "setEntitiesSelectedCommunes",
            "setEntitiesSelectedTags",
            "setEntitiesSelectedTourismSectors",
            "setEntitiesEmailSearch",
        ]),
    },
    computed: {
        ...mapState("account", [
            "tags",
            "categories",
            "communes",
            "account",
            "tourismSectors",
        ]),
        ...mapState("entitiesFilter", [
            "entitiesSearch",
            "entitiesSelectedTags",
            "entitiesSelectedCommunes",
            "entitiesSelectedTourismSectors",
            "canSearch",
            "entitiesEmailSearch",
        ]),
    },
    created() {
        this.$store.dispatch("account/fetchEntitiesCommunes")

        if(this.account.tis_type.code === 'DAHUB_QUEBEC') {
            this.cityWording = 'Municipalité'
        }

        this.$store.dispatch('account/fetchTags')
    },
}
</script>